import { FC } from 'react';
import cn from 'classnames';

import { PsychicImageModule } from 'entities/PsychicPhotoModules';
import { PsychicRatingLine } from 'entities/PsychicRatingLine';
import { PsychicPhotoModule } from 'constants/enums';
import { DataLink } from 'components/Shared/SharedComponents';

import styles from './styles.module.scss';

import { CardInterface } from '../config/declarations';

const FifteenFreeCard: FC<CardInterface> = ({ psychic, psychicSkeleton }) => {
  const avatarUrl = psychicSkeleton.avatar?.url || '';
  const detailsButton = psychicSkeleton.detailsButton!;

  return (
    <li className={cn(styles.card, styles.freeOffer)}>
      <DataLink href={detailsButton.src as string}>
        <PsychicImageModule
          view={PsychicPhotoModule.WITH_SELECTION}
          psychic={psychic}
          psychicSkeleton={psychicSkeleton}
          src={psychic.psychicImageUrl || avatarUrl || ''}
        />
        <PsychicRatingLine
          overallScore={psychic.overallScore}
          psychicFrame={psychicSkeleton}
          responses={psychic.responses}
          styles={styles}
        />
      </DataLink>

      <DataLink link={detailsButton} className={styles.text}>
        {detailsButton.title}
      </DataLink>
    </li>
  );
};

export default FifteenFreeCard;
